import React from 'react'
import clsx from 'clsx'
import MuiCheckbox from '@material-ui/core/Checkbox'
import useStyles from './styles'

const Checkbox = props => {
  const classes = useStyles()
  return (
    <MuiCheckbox
      className={classes.root}
      checkedIcon={<span className={clsx(classes.icon, classes.checkedIcon)} />}
      indeterminateIcon={
        <span className={clsx(classes.icon, classes.indeterminateIcon)} />
      }
      icon={<span className={classes.icon} />}
      inputProps={{ 'aria-label': 'decorative checkbox' }}
      {...props}
    />
  )
}

export default Checkbox
